import catchify from 'catchify';
import { SMART_COLLECTIONS_URL } from '@/constants/api';

export const getCollections = async ($cachios) => {
  const [err, collections] = await catchify($cachios.get(`${SMART_COLLECTIONS_URL}/?format=json&per_page=999`));

  if (err || !collections || !collections.data || !collections.data.smart_collections) {
    return [];
  }

  return collections.data.smart_collections;
};

export default {
  getCollections,
};
